<template>
  <v-slider
    v-model="inputValue"
    :min="min"
    :max="max"
    color="orange darken-3"
    class="align-center"
    :disabled="disabled"
    step="25"
    always-dirty
    hide-details
  >
    <template v-slot:prepend>
      <v-icon
        @click="decrement"
      >
        mdi-minus
      </v-icon>
    </template>

    <template v-slot:append>
      <v-icon
        @click="increment"
      >
        mdi-plus
      </v-icon>
    </template>
  </v-slider>
</template>
<script>
export default {
  name: 'arb-slider-input',
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: Number,
    max: Number,
    disabled: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 25
    }
  },
  data () {
    return {
      inputValue: this.value
    }
  },
  watch: {
    inputValue (val) {
      this.$emit('input', val)
      this.$emit('changeEventHandler', val)
    }
  },
  methods: {
    decrement () {
      this.inputValue -= this.step
    },
    increment () {
      this.inputValue += this.step
    }
  }
}
</script>
